import { api } from '~/lib/api-client';

/**
 * FRONT-2555: a typed yes or no sent while Eddy's turn is still running —
 * the moment an approval card is usually on screen, since the turn waits on
 * it. The composer can't start a new turn then, so it asks the server first
 * whether the text answers the open card outright. The server decides (same
 * rules as a typed reply, src/autonomy/card-answer.ts); `false` means "not an
 * answer", and the composer queues the message exactly as before. A failed
 * request is also `false`: the message is never lost, only queued.
 */
/** A turn waiting on a card can starve the browser's connections; past this
 *  the message simply stays queued. */
const ANSWER_CHECK_TIMEOUT_MS = 5_000;

export async function answerCardByText(sessionId: string, text: string): Promise<boolean> {
  try {
    const res = await api.post<{ handled?: boolean }>(
      '/api/approvals/answer-text',
      { sessionId, text },
      AbortSignal.timeout(ANSWER_CHECK_TIMEOUT_MS),
    );
    return res?.handled === true;
  } catch {
    return false;
  }
}
